module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold.27d0433a.ttf";